<template>
  <div class="d-layout-simple">
    <div
      ref="body"
      v-loading="loading"
      class="d-body"
    >
      <slot />
    </div>

    <div
      class="d-menu-desktop"
      :class="{'is-filled': (scrolled && transparent)|| !transparent}"
    >
      <div class="container is-fluid">
        <router-link
          to="/"
          class="d-brand"
        >
          <slot name="brand">
            <img
              src="/img/logo.svg"
              alt="SAUVéR"
            >
          </slot>
        </router-link>
        <div class="d-navbar">
          <slot name="menu-desktop" />
        </div>

        <v-account-dropdown :show-accout-details="false" />
      </div>
    </div>

    <div class="d-menu-mobile">
      <slot name="menu-mobile" />
    </div>

    <v-pwa-prompt />
  </div>
</template>

<script>
import PwaPromptVue from "./includes/PwaPrompt.vue";
import AccountDropdownVue from "./includes/AccountDropdown.vue";
export default {
  metaInfo() {
    return {
      titleTemplate:  "%s - " + this.$laravel.app.name,
      lang: this.$laravel.app.locale
    };
  },
  components: {
    "v-pwa-prompt": PwaPromptVue,
    "v-account-dropdown": AccountDropdownVue
  },
  props: {
    loading: {
      default: false,
      type: Boolean
    },
    transparent: {
      default: true,
      type: Boolean
    }
  },
  data() {
    return {
      scrolled: false
    };
  },
  watch: {
    "$route" () {
      this.$refs.body.scrollTop = 0;
    }
  },
  mounted () {
    this.$refs.body.addEventListener("scroll", this.onScroll);
  },
  beforeDestroy() {
    this.$refs.body.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    onScroll() {
      if (this.$refs.body.scrollTop > 15) {
        this.scrolled = true;
      } else {
        this.scrolled = false;
      }
    }
  }
};
</script>
